import { PcvizUploadConfig, PcvizJobProcessData } from '@mirage-projects/cw-models';

import { WizardSummaryData } from '../models/wizard-summary-data';
/**
 * Abstract service definition to manage the upload endpoints
 */
export abstract class UploadService {
    /**
     * Upload and process a project
     * @param config Configuration of the upload
     * @param summary Summary of the project
     */
    abstract uploadAndProcessProject(config: PcvizUploadConfig, summary: Partial<WizardSummaryData>[], jobSiteId?: number): Promise<void>;

    /**
     * Upload and process a layer
     * @param config Configuration of the upload
     */
    abstract uploadAndProcessLayer(config: PcvizUploadConfig): Promise<void>;

    abstract getContextCaptureEstimationCost(projectId: number, config: Partial<PcvizJobProcessData>): Promise<any>;

    abstract createAndUploadJobSiteReferenceData(config: PcvizUploadConfig): Promise<void>;
}
